$(document).ready(function(){

    if($('[data-js-popup]').length){

        //popup open
        $(document).on('click', '[data-js-popup-open]' , function(){

            var this_popup = $(this).data('js-popup-open');

            $('[data-js-popup="' + this_popup + '"], #mask').fadeIn(200).addClass('open');
            
        });
        
        //popup dismiss
        $(document).on('click', '[data-js-popup-dismiss]' , function(){

            var this_popup = $(this).data('js-popup-dismiss');

            $('[data-js-popup="' + this_popup + '"], #mask').removeClass('open').fadeOut(200);
            
        });
        
        //popup dismiss - click on mask
        $(document).on('click', '#mask.open' , function(){
            $('[data-js-popup].open, #mask.open').removeClass('open').fadeOut(200);
        });
        
    }

    // private sale popup
    $('.popup--private-sale button.private_sale_submit').click(function(e){
        e.preventDefault();
        var form = $('.popup--private-sale form');
        form.find('input').removeClass('error');
        form.find('.label_check').removeClass('label_check--error');
        form.find('.email_icon').addClass("loading");
        
        var accept = form.find('input[name="agree_private_sale"]').prop("checked");
        if(accept == true){
            if (digitalgolf.toolbox.checkMailFormat(form.find('[name="private-sale-email"]').val()))
            {
                $.ajax(
                {
                    type: "POST",
                    url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + form.data('service'),
                    data: {
                        'email': form.find('input[name="private-sale-email"]').val(),
                        'agree_private_sale': '1'
                    },
                    dataType: 'json',
                    xhrFields: {withCredentials: true}
                }).done(function(result) {
                    form.find('.email_icon').removeClass("loading");
                    if (result.success == false) {
                        $.each(result.invalid, function( index, errorName ) {
                            form.find('[name="' + errorName + '"]').addClass('error'); 
                        });        
                        form.find('.label_check').addClass('label_check--error');
                    } else if (result.success == true) {    
                        form.addClass('submitted');
                        form.find('.email_icon').addClass("success");
                        form.find('button').attr('disabled','disabled');
                    } 
                });
            }
            else
            {
                form.find('input[name="private-sale-email"]').addClass('error');
                form.find('.email_icon').removeClass("loading");
                
            }
        } else {
            form.find('.label_check').addClass('label_check--error');
            form.find('.email_icon').removeClass("loading");
            return false;
        }
    });

// END doc ready
});